// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-radio-label {
  font-size: 13px;
}

.auth-app p {
  color: var(--ion-color-secondary);
  font-family: var(--font-secondary) !important;
  font-weight: 500;
  font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/authenticator/authenticator-option/authenticator-option.component.scss"],"names":[],"mappings":"AACA;EACI,eAAA;AAAJ;;AAII;EACE,iCAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;AADN","sourcesContent":["\r\n.custom-radio-label {\r\n    font-size: 13px;\r\n}\r\n\r\n.auth-app{\r\n    p{\r\n      color: var(--ion-color-secondary);\r\n      font-family: var(--font-secondary) !important;\r\n      font-weight: 500;\r\n      font-size: 22px;\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
